import { useSelector } from "react-redux";
export default function useIsPremiumUser() {
    const user = useSelector(state => state.user);
    //check isPremium premiumExpiry
    let isPremium = false;
    if (user.isPremium && user.premiumExpiry && (new Date(user.premiumExpiry) >= new Date())) {
        isPremium = true;
    }
    return isPremium;
}
